/**
 * Contentful Utilities
 * Anything related to data that Contentful returns
 */

export function getRichRelevanceModule(entry) {
    return _.head(_.filter(entry.fields.modules, (module) => _.get(module, 'fields.contentType') === 'richRelevancePlacementModule'));
}

export function getCurrencyFormattingInfo(state, currencyCode) {
    const currenciesConfigs = state.core.featureConfigs.currencies;
    let currencyInfo;

    if (currenciesConfigs && currenciesConfigs.currencies) {
        currencyInfo = _.find(currenciesConfigs.currencies, (c) => c.fields.currencyCode === currencyCode);
        currencyInfo = currencyInfo.fields;
    }

    return currencyInfo;
}
